<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    v-model="drawer"
    :dark="barColor !== 'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)'"
    :expand-on-hover="expandOnHover"
    :right="$vuetify.rtl"
    :src="barImage"
    mobile-break-point="960"
    app
    width="260"
    v-bind="$attrs"
  >
    <template v-slot:img="props">
      <!-- <v-img
        :gradient="`to bottom, ${barColor}`"
        v-bind="props"
      /> -->
      <v-img
          :src="require('@/assets/bg.png')"
          gradient="to top right, rgba(38, 107, 105, .6), rgba(38, 107, 105, .6)"
          
          v-bind="props"
        ></v-img>
    <v-divider class="mb-1" />

    </template>


    <v-list
      dense
      nav
      v-if="user"
    >
      <v-list-item>
        <v-list-item-avatar
          class="align-self-center"
          color="white"
          contain
        >
          <!-- <v-img
            src="https://demos.creative-tim.com/vuetify-material-dashboard/favicon.ico"
            max-height="30"
          /> -->
          <v-icon light>mdi-account</v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title
            class="display-1"
            v-text="profile.title"
          />
        </v-list-item-content>
      </v-list-item>
    </v-list>



    <v-list
      expand
      nav
    >
      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />
      <div class="hidden-sm-and-up">
        
        <v-divider class="mb-1" />
        <template v-for="(item, i) in homeNavLinks">
          <base-item-group
            v-if="item.children"
            :key="`group-${i}`"
            :item="item"
          >
            <!--  -->
          </base-item-group>

          <base-item
            v-else
            :key="`item-${i}`"
            :item="item"
          />
        </template>
      </div>
    
      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />
    </v-list>

    <v-divider class="mb-2" />

    <v-list
      expand
      nav
    >
      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />
<div v-if="user">
      <template v-for="(item, i) in computedItems">
        <base-item-group
          v-if="item.children"
          :key="`group-${i}`"
          :item="item"
        >
          <!--  -->
        </base-item-group>

        <base-item
          v-else
          :key="`item-${i}`"
          :item="item"
        />
      </template>
</div>
      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />

    <v-divider class="mb-1" />
     <v-list-item @click="login_dialog({ show: true })" v-if="!user">
            <v-list-item-icon>
                <v-icon>mdi-account-arrow-left</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Log In</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            
     <v-list-item @click="logout" v-if="user">
            <v-list-item-icon>
                <v-icon>mdi-account-arrow-right</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Log Out</v-list-item-title>
              </v-list-item-content>
            </v-list-item>


    </v-list>
    


    <!-- <template v-slot:append>
 
      <v-list-item @click="logout">
            <v-list-item-icon>
                <v-icon>mdi-account-arrow-right</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Log Out</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
    </template> -->
  </v-navigation-drawer>
</template>

<script>
  // Utilities
  import {
    mapState, mapActions, mapMutations
  } from 'vuex'

  export default {
    name: 'DashboardCoreDrawer',

    props: {
      expandOnHover: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      items: [
        {
          icon: 'mdi-view-dashboard',
          title: 'dashboard',
          to: '/dashboard/index',
        },
        {
          icon: 'mdi-speedometer',
          title: 'weightdiary',
          to: '/dashboard/pages/weight-diary',
        },
        {
          icon: 'mdi-nutrition',
          title: 'fooddiary',
          to: '/dashboard/pages/food-diary',
        },
        {
          icon: 'mdi-credit-card',
          title: 'subscription',
          to: '/dashboard/pages/subscription',
        },
        {
          icon: 'mdi-account',
          title: 'user',
          to: '/dashboard/pages/user',
        },
        // {
        //   title: 'typography',
        //   icon: 'mdi-format-font',
        //   to: '/dashboard/components/typography',
        // },
        // {
        //   title: 'icons',
        //   icon: 'mdi-chart-bubble',
        //   to: '/dashboard/components/icons',
        // },
        // {
        //   title: 'google',
        //   icon: 'mdi-map-marker',
        //   to: '/dashboard/maps/google-maps',
        // },
        // {
        //   title: 'notifications',
        //   icon: 'mdi-bell',
        //   to: '/dashboard/components/notifications',
        // },
      ],
      homeNavLinks: [
        { icon: 'mdi-home', title: 'Home', to:'/' },
        // { icon: 'mdi-minus', title: 'About', to:'/#About' },
        // { icon: 'mdi-minus', title: 'Features', to:'/#Features' },
        // { icon: 'mdi-minus', title: 'Get Motiplate', to:'/#Pricing' },
        // { icon: 'mdi-minus', title: 'Contact', to:'/#Contact' },
      ]
    }),

    computed: {
      ...mapState('Ui', ['barColor', 'barImage']),
      ...mapState('User', ['user']),
      drawer: {
        get () {
          return this.$store.state.Ui.drawer
        },
        set (val) {
          this.$store.commit('Ui/set_drawer', val)
        },
      },
      computedItems () {
        return this.items.map(this.mapItem)
      },
      profile () {
        return {
          avatar: true,
          title: this.user.name// this.$t('avatar'),
        }
      },
    },

    methods: {
      ...mapActions('User', ['logout']),
      ...mapMutations('Ui', ['login_dialog']),
      mapItem (item) {
        return {
          ...item,
          children: item.children ? item.children.map(this.mapItem) : undefined,
          title: this.$t(item.title),
        }
      },
    },
  }
</script>

<style lang="sass">
  @import '~vuetify/src/styles/tools/_rtl.sass'

  #core-navigation-drawer
    .v-list-group__header.v-list-item--active:before
      opacity: .24

    .v-list-item
      &__icon--text,
      &__icon:first-child
        justify-content: center
        text-align: center
        width: 20px

        +ltr()
          margin-right: 24px
          margin-left: 12px !important

        +rtl()
          margin-left: 24px
          margin-right: 12px !important

    .v-list--dense
      .v-list-item
        &__icon--text,
        &__icon:first-child
          margin-top: 10px

    .v-list-group--sub-group
      .v-list-item
        +ltr()
          padding-left: 8px

        +rtl()
          padding-right: 8px

      .v-list-group__header
        +ltr()
          padding-right: 0

        +rtl()
          padding-right: 0

        .v-list-item__icon--text
          margin-top: 19px
          order: 0

        .v-list-group__header__prepend-icon
          order: 2

          +ltr()
            margin-right: 8px

          +rtl()
            margin-left: 8px
</style>
